import { formatCurrency } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

// enums
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

// interfaces
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * 
 */
export interface IPriceHandler { title: string, value: string, toString: string }

@Pipe({
    standalone: true,
    name: 'PriceHandler',
})
export class PriceHandlerPipe implements PipeTransform {


    // fields
    /**
     * @description Advertisement Data
     */
    private _data: IAdvertisementResponse = null;

    /**
     * @description priceType is depend on categoryType
     */
    private _priceTitle: string = null;
    

    /**
     * 
     * @param data 
     * @returns 
     */
    transform(data: IAdvertisementResponse): IPriceHandler {

        
        /**
         * handler expression
        */
       try {
           
            /**
            * throw expression
            */
            if (data == null) throw `arg data is: => ${data}`

            /**
             * set
             */
            this._data = data;

            /**
             * 
             */
            return this._handlerPriceWithCategories;
            

        }
        catch (err: any) {
            new Error(err);
            return null;
        }

    }

    // getters

    /**
     * 
     */
    private get _handlerPriceWithCategories(): IPriceHandler {

        // ES6 Destruction
        const { category: { type } } = this._data;

        /**
         * handler PriceTitle depend on CategoryType 
         */
        switch(type) {
            case CATEGOR_VALUE_TYPE.BL:
            case CATEGOR_VALUE_TYPE.VL:
            case CATEGOR_VALUE_TYPE.PL:
            case CATEGOR_VALUE_TYPE.OFF_PLAN:
                /**
                 * 
                 */
                this._priceTitle = 'اسعار تبدأ من';
                break;
            case CATEGOR_VALUE_TYPE.LN:
                /**
                 * 
                 */
                this._priceTitle = "سعر المتر";
                break;
            default:
                /**
                 * 
                 */
                this._priceTitle = "السعر";
                break;

                // if (contractType == Contract_Type.SE) return { title: 'سعر البيع', value: this._handlerPrice, toString: `سعر البيع ${this._handlerPrice}`}

                // if (contractType == Contract_Type.RT) return { title: 'سعر الايجار', value: this._handlerPrice, toString: `سعر الايجار ${this._handlerPrice}`}
        }

        /**
         * 
         */
        return { title: this._priceTitle, value: this._handlerPrice, toString: this.toString() };

    }

    /**
     * 
     */
    private get _handlerPrice() {

        // ES6 Destruction
        const { price } = this._data;

        /**
         * handler undefined prices
         */
        if (price == null) return '----';

        /**
         * handler single price
         */
        return formatCurrency(price, 'en-US', '', '', '0.0-0').trim();


        /**
         * handler range prices
         */
        // return formatCurrency(priceFrom, 'en-US', '', '', '0.0-0').trim() + ' - ' + formatCurrency(priceTo, 'en-US', '', '', '0.0-0').trim()

    }

    /**
     * 
     * @returns string of title + price
     */
    public toString(): string {
        return `${this._priceTitle} ${this._handlerPrice}`
    }

}
